import uploadsarticlesassaultWithDeadlyWeaponAttorneySacramentoimagecourtroomGavelSacramentoJpg from "$lib/data/generated/uploads/articles/assault-with-deadly-weapon-attorney-sacramento/image/courtroom-gavel-sacramento.jpg";

export const uploads = {
  "uploads/articles/assault-with-deadly-weapon-attorney-sacramento/image/courtroom-gavel-sacramento.jpg": uploadsarticlesassaultWithDeadlyWeaponAttorneySacramentoimagecourtroomGavelSacramentoJpg
};